import React from 'react';
import { mapInternetEditOffers } from '../util/InternetOfferUtil';
export const InternetEditProvider = (props) => {
    const [internetOfferCards, setInternetOfferCards] = React.useState(mapInternetEditOffers(props.offers, props.auth));
    const [address, setAddress] = React.useState(props.address);
    const [room, setRoom] = React.useState(props.room);
    React.useEffect(() => {
        setInternetOfferCards(mapInternetEditOffers(props.offers, props.auth));
    }, [props.offers, props.onInternetSelect, props.auth]);
    React.useEffect(() => {
        setRoom(props.room);
    }, [props.room]);
    React.useEffect(() => {
        setAddress(props.address);
    }, [props.address]);
    return (React.createElement(InternetEditContext.Provider, { value: {
            internetOfferCards,
            address,
            room,
        } }, props.children));
};
const InternetEditContext = React.createContext({
    internetOfferCards: [],
    address: undefined,
    room: undefined,
});
export const useInternetEditOffers = () => {
    return React.useContext(InternetEditContext);
};
